export default __webpack_public_path__ + "static/media/route-modal-image.38176a29.png";